export default __webpack_public_path__ + "static/ciel_intro_480-dfe0f49dcc6290359be2c33ac4ff4eb0.mp4";